import React, { FC, useState } from 'react'
import { useForm } from 'react-hook-form'
import toast, { Toaster } from 'react-hot-toast'
import authService from '../../../../Services/authService'

import './Settings.scss'
import { Link } from 'react-router-dom'
import { useAuth } from '../../../../Components/AuthProvider/AuthProvider'

const Settings: FC = () => {
  type FormValues = {
    firstname: string;
    lastname: string;
    email: string;
    username: string;
    pass: string;
    repass: string;
    name: string;
    role: string;
  };

  const [submit, setSubmit] = useState(false)

  const { register, handleSubmit, formState: { errors } } = useForm<FormValues>()

  const onSubmit = handleSubmit((data) => processSignup(data))

  const { user } = useAuth()
  console.log('user', user)
  const processSignup = async (data: FormValues) => {
    console.log(data)
    setSubmit(true)
    await authService.profileUpdate({ username: data.username, password: data.pass }).then((res: any) => {
      console.log('Suucess data', res)
      setSubmit(false)
      toast.success('Account updated succesfully', { duration: 20000, className: 'bg-success text-white' })
    }, (error) => {
      toast.error(error.message, { duration: 20000, className: 'bg-danger text-white' })
      console.log(error.message)
      setSubmit(false)
    })
  }
  return (
    <div className="settings-page">
      <div className="container-fluid px-4">
        {/* Header Section */}
        <div className="settings-header">
          <div className="breadcrumb-section">
            <Link to="/dashboard" className="breadcrumb-link">
              <i className='fa fa-home'></i> Dashboard
            </Link>
            <span className='breadcrumb-separator'>/</span>
            <span className="breadcrumb-current">Settings</span>
          </div>

          <div className="header-content">
            <div className="header-title-section">
              <h1 className="page-title">Account Settings</h1>
              <p className="page-subtitle">Manage your account information and security</p>
            </div>
          </div>
        </div>

        <div className="row g-4">
          {/* Profile Card */}
          <div className="col-lg-4">
            <div className="profile-card">
              <div className="profile-header">
                <div className="profile-avatar">
                  <div className="avatar-circle">
                    <i className="fa fa-user"></i>
                  </div>
                </div>
                <h3 className="profile-name">{user?.firstname} {user?.lastname}</h3>
                <p className="profile-role">{user?.mainRole}</p>
              </div>
              <div className="profile-info">
                <div className="info-item">
                  <i className="fa fa-envelope info-icon"></i>
                  <div className="info-content">
                    <div className="info-label">Email</div>
                    <div className="info-value">{user?.username}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Settings Form */}
          <div className="col-lg-8">
            <div className="settings-card">
              <div className="settings-card-header">
                <h2 className="card-title">
                  <i className="fa fa-cog"></i> Profile Information
                </h2>
              </div>
              <div className="settings-card-body">
                <form onSubmit={onSubmit}>
                  {/* Personal Information Section */}
                  <div className="form-section">
                    <h3 className="section-title">Personal Information</h3>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <div className="modern-form-group">
                          <label className="modern-label">First Name</label>
                          <input
                            {...register('firstname')}
                            className="modern-input"
                            defaultValue={user?.firstname}
                            placeholder="Enter your first name"
                          />
                          {errors.firstname && (
                            <div className="error-message">
                              <i className="fa fa-exclamation-circle"></i>
                              {errors.firstname.message}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="modern-form-group">
                          <label className="modern-label">Last Name</label>
                          <input
                            {...register('lastname')}
                            className="modern-input"
                            defaultValue={user?.lastname}
                            placeholder="Enter your last name"
                          />
                          {errors.lastname && (
                            <div className="error-message">
                              <i className="fa fa-exclamation-circle"></i>
                              {errors.lastname.message}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="modern-form-group">
                          <label className="modern-label">Email Address</label>
                          <input
                            {...register('email')}
                            className="modern-input"
                            defaultValue={user?.username}
                            placeholder="Enter your email"
                          />
                          {errors.email && (
                            <div className="error-message">
                              <i className="fa fa-exclamation-circle"></i>
                              {errors.email.message}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="modern-form-group">
                          <label className="modern-label">Role</label>
                          <input
                            {...register('role')}
                            className="modern-input"
                            defaultValue={user?.mainRole}
                            disabled
                          />
                          {errors.role && (
                            <div className="error-message">
                              <i className="fa fa-exclamation-circle"></i>
                              {errors.role.message}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Security Section */}
                  <div className="form-section">
                    <h3 className="section-title">Security</h3>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <div className="modern-form-group">
                          <label className="modern-label">New Password</label>
                          <input
                            type="password"
                            {...register('pass')}
                            className="modern-input"
                            placeholder="Enter new password"
                          />
                          {errors.pass && (
                            <div className="error-message">
                              <i className="fa fa-exclamation-circle"></i>
                              {errors.pass.message}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="modern-form-group">
                          <label className="modern-label">Confirm Password</label>
                          <input
                            type="password"
                            {...register('repass')}
                            className="modern-input"
                            placeholder="Confirm new password"
                          />
                          {errors.repass && (
                            <div className="error-message">
                              <i className="fa fa-exclamation-circle"></i>
                              {errors.repass.message}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Form Actions */}
                  <div className="form-actions">
                    {!submit && (
                      <button type="submit" className="save-button">
                        <i className="fa fa-save"></i>
                        Save Changes
                      </button>
                    )}
                    {submit && (
                      <button type="button" className="save-button saving" disabled>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Saving...
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Toaster />
    </div>
  )
}
export default Settings
